import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function isVimeoUrl(url) {
  return Boolean(url && url.includes('vimeo.com'));
}

// Remove o código do descritor SAEB do início de um título (ex.: "D12 · ", "2P4.1 · ",
// "5AL1.3: "): token alfanumérico com pelo menos 1 dígito, seguido de separador.
export function stripDescriptorCode(text) {
  return (text || '').replace(/^(?=[A-Za-z0-9.]*\d)[A-Za-z0-9.]+\s*[·:—–-]\s*/, '');
}
